import { HTMLAttributes, useEffect, useRef, useState } from 'react';
import * as S from './CodeInput.styled';

export interface CodeInputProps extends HTMLAttributes<HTMLDivElement> {
  fields?: number;
  isFetching?: boolean;
  isError?: boolean;
  onFocus?: () => void;
  setVerificationCode: (code: string) => void;
  resetCode?: boolean;
}

// TODO: fetching중 일때도 구현해야함
export default function CodeInput({
  fields = 6,
  isError,
  onFocus,
  isFetching,
  setVerificationCode,
  resetCode,
  ...props
}: CodeInputProps) {
  const MAX_CODE_INPUT = fields;
  const initialCodeState = new Array<''>(fields).fill('');

  const codeInputRefs = useRef<HTMLInputElement[]>([]);
  const [inputCodeState, setInputCodeState] = useState<string[]>([
    ...initialCodeState,
  ]);

  const handleCodeFocus = (index: number) => {
    onFocus?.();
    setInputCodeState((prev) => {
      for (let i = index; i < MAX_CODE_INPUT; i++) {
        prev[i] = '';
      }
      return [...prev];
    });
  };

  const handleCodeChange = (e: React.ChangeEvent, index: number) => {
    const value = (e.target as HTMLInputElement).value;

    if (value.length > 1) {
      const inputValues = value.split('');
      const lastValue = inputValues[inputValues.length - 1];
      setInputCodeState((prev) => {
        prev[index] = lastValue;
        return [...prev];
      });
    } else {
      setInputCodeState((prev) => {
        prev[index] = value;
        return [...prev];
      });
    }
    if (index !== MAX_CODE_INPUT - 1) {
      codeInputRefs.current[index + 1].focus();
      return;
    } else {
      codeInputRefs.current[index].blur();
    }
  };

  useEffect(() => {
    setInputCodeState([...initialCodeState]);
  }, []);

  useEffect(() => {
    if (resetCode) {
      setInputCodeState([...initialCodeState]);
      // 첫 번째 입력 필드에 포커스 (선택적)
      if (codeInputRefs.current[0]) {
        codeInputRefs.current[0].focus();
      }
    }
  }, [resetCode]);

  useEffect(() => {
    const code = inputCodeState.join('');
    setVerificationCode(code);

    // if (code.length === MAX_CODE_INPUT) {
    //   // onCompleteCode(code);
    // }
  }, [inputCodeState, MAX_CODE_INPUT, setVerificationCode]);

  return (
    <S.Container {...props}>
      {inputCodeState.map((el, index) => (
        <S.Input
          ref={(el) => {
            if (el) codeInputRefs.current[index] = el;
          }}
          key={index}
          type='number'
          min='0'
          max='9'
          name={`number-code-${index}`}
          pattern='[0-9]*'
          value={el}
          inputMode='numeric'
          onChange={(e) => handleCodeChange(e, index)}
          onFocus={() => handleCodeFocus(index)}
          required
          isError={isError}
        />
      ))}
    </S.Container>
  );
}
